var _jsxFileName = "/home/runner/_work/smpackages/smpackages/packages/webassets/src/components/Header/components/LogInCTA/index.js",
  _this = this;
import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@wds/box';
import { Button } from '@wds/button';
import { createURL } from '@sm/utils';
import { T, defineMessages } from '@sm/intl';
export var COPY = defineMessages({
  LOG_IN: {
    id: 'LogInCTA.logInButton',
    defaultMessage: 'Log in',
    description: '[Type: Label][Vis.: high] - This is the LogIn button on the header.'
  }
});
export var LogInCTA = function LogInCTA(_ref) {
  var variant = _ref.variant,
    size = _ref.size,
    color = _ref.color,
    className = _ref.className,
    stretched = _ref.stretched,
    params = _ref.params;
  return /*#__PURE__*/React.createElement(Box, {
    display: stretched ? 'flex' : 'inline-flex',
    className: className,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Button, {
    "data-testid": "LogInCTA__Btn",
    variant: variant,
    size: size,
    color: color,
    stretched: stretched,
    href: createURL('/login', params),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.LOG_IN,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35,
      columnNumber: 9
    }
  })));
};
LogInCTA.propTypes = {
  variant: PropTypes.string,
  size: PropTypes.string,
  color: PropTypes.string,
  stretched: PropTypes.bool,
  className: PropTypes.string,
  params: PropTypes.oneOfType([PropTypes.object])
};
LogInCTA.defaultProps = {
  variant: 'text',
  size: 'sm',
  color: 'secondary',
  stretched: false,
  className: '',
  params: null
};
export default LogInCTA;
//# sourceMappingURL=index.js.map